import { render } from "./fields.vue?vue&type=template&id=db41ccda"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__